import { lazyWithRetry } from "@outschool/ui-utils";
import React from "react";

import { useLearnerClassroomContext } from "../../providers/LearnerClassroomProvider";
import LearnerClassroomPage from "./LearnerClassroomPage";

const ClassroomAssignmentsPage = lazyWithRetry(() =>
  import("./ClassroomAssignmentsPage").then(m => ({
    default: m.ClassroomAssignmentsPage,
  })),
);
const ClassroomLessonsPage = lazyWithRetry(() =>
  import("./ClassroomLessonsPage").then(m => ({
    default: m.ClassroomLessonsPage,
  })),
);
const ClassroomLessonsPageV2 = lazyWithRetry(() =>
  import("./ClassroomLessonsPageV2").then(m => ({
    default: m.ClassroomLessonsPageV2,
  })),
);
const PrivateClassMessagesPage = lazyWithRetry(
  () => import("./PrivateClassMessagesPage"),
);
const RecordingPage = lazyWithRetry(() => import("./RecordingPage"));
const SectionJoinPage = lazyWithRetry(() => import("./SectionJoinPage"));
const SinglePostPage = lazyWithRetry(() => import("./SinglePostPage"));

export const tabValues = {
  Classroom: "classroom",
  Lessons: "lessons",
  Assignments: "assignments",
  PrivateClassMessages: "private-class-messages",
};

const LessonsPageByLayout = ({ lessonUid }: { lessonUid?: string }) => {
  const { section, syllabus } = useLearnerClassroomContext();
  const isV2Layout = syllabus?.layoutVersion === 2;
  const isSelfPaced = section?.is_self_paced === true;

  if (isV2Layout && isSelfPaced) {
    return <ClassroomLessonsPageV2 lessonUid={lessonUid} />;
  }
  return <ClassroomLessonsPage lessonUid={lessonUid} />;
};

export const classroomRoutes: {
  [key: string]: (routeParams: { [key: string]: string }) => {
    value?: string;
    renderPage: () => JSX.Element;
  };
} = {
  "/": () => ({
    value: tabValues.Classroom,
    renderPage: () => <LearnerClassroomPage />,
  }),
  "/lessons": () => ({
    value: tabValues.Lessons,
    renderPage: () => <LessonsPageByLayout />,
  }),
  "/lessons/:lessonUid": ({ lessonUid }) => ({
    value: tabValues.Lessons,
    renderPage: () => <LessonsPageByLayout lessonUid={lessonUid} />,
  }),
  "/assignments": () => ({
    value: tabValues.Assignments,
    renderPage: () => <ClassroomAssignmentsPage />,
  }),
  "/join/:enrollmentUid": ({ enrollmentUid }) => ({
    renderPage: () => <SectionJoinPage enrollmentUid={enrollmentUid} />,
  }),
  "/private-class-messages": () => ({
    value: tabValues.PrivateClassMessages,
    renderPage: () => <PrivateClassMessagesPage />,
  }),
  "/posts/:classPostUid": ({ classPostUid }) => ({
    renderPage: () => <SinglePostPage classPostUid={classPostUid} />,
  }),
  "/recording/:recordingUid": ({ recordingUid }) => ({
    renderPage: () => <RecordingPage recordingUid={recordingUid} />,
  }),
};
